import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { FacilityModel } from "../../../../../main/facilities/api/types";

export interface IFacilitiesDropdownState {
  pageNumber: number;
  pageSize: number;
  anchorEl: null | HTMLElement;
  selectedFacility: FacilityModel | undefined;
  setSelected: (val?: FacilityModel) => void;
  setAnchorEl: (anchorEl: null | HTMLElement) => void;
  setPageNumber: (val: number) => void;
  setPageSize: (val: number) => void;
}

const initialData = {
  pageNumber: 1,
  pageSize: 100,
  anchorEl: null,
  selectedFacility: undefined,
};

const useFacilitiesDropdownStore = create<IFacilitiesDropdownState>()(
  persist(
    (set) => ({
      ...initialData,
      setSelected: (selectedFacility) => set({ selectedFacility }),
      setAnchorEl: (anchorEl) => set({ anchorEl }),
      setPageNumber: (pageNumber) => set({ pageNumber }),
      setPageSize: (pageSize) => set({ pageSize }),
    }),
    {
      name: "facilities-dropdown-store",

      partialize: (state) => ({
        selectedFacility: state.selectedFacility,      
        pageNumber: state.pageNumber,
        pageSize: state.pageSize,   
      }),
    }
  )
);

export default useFacilitiesDropdownStore;
